// extracted by mini-css-extract-plugin
export default {"popupWrapper":"popupWrapper__XiT-r"};